export * from './abmChangeAction.service';
import { AbmChangeActionService } from './abmChangeAction.service';
export * from './abmChangeEvent.service';
import { AbmChangeEventService } from './abmChangeEvent.service';
export * from './abmQueuedChange.service';
import { AbmQueuedChangeService } from './abmQueuedChange.service';
export * from './abmSequence.service';
import { AbmSequenceService } from './abmSequence.service';
export * from './abmSequenceHistory.service';
import { AbmSequenceHistoryService } from './abmSequenceHistory.service';
export * from './appUser.service';
import { AppUserService } from './appUser.service';
export * from './bomImportFile.service';
import { BomImportFileService } from './bomImportFile.service';
export * from './bomRecordImport.service';
import { BomRecordImportService } from './bomRecordImport.service';
export * from './bomRecordQuarantine.service';
import { BomRecordQuarantineService } from './bomRecordQuarantine.service';
export * from './company.service';
import { CompanyService } from './company.service';
export * from './grade.service';
import { GradeService } from './grade.service';
export * from './gradeTranslation.service';
import { GradeTranslationService } from './gradeTranslation.service';
export * from './inventory.service';
import { InventoryService } from './inventory.service';
export * from './metadata.service';
import { MetadataService } from './metadata.service';
export * from './nestingCutlist.service';
import { NestingCutlistService } from './nestingCutlist.service';
export * from './nestingCutlistDetail.service';
import { NestingCutlistDetailService } from './nestingCutlistDetail.service';
export * from './nestingCutlistNest.service';
import { NestingCutlistNestService } from './nestingCutlistNest.service';
export * from './nestingCutlistNestDetail.service';
import { NestingCutlistNestDetailService } from './nestingCutlistNestDetail.service';
export * from './project.service';
import { ProjectService } from './project.service';
export * from './purchaseOrder.service';
import { PurchaseOrderService } from './purchaseOrder.service';
export * from './purchaseOrderItem.service';
import { PurchaseOrderItemService } from './purchaseOrderItem.service';
export * from './requisition.service';
import { RequisitionService } from './requisition.service';
export * from './requisitionItem.service';
import { RequisitionItemService } from './requisitionItem.service';
export * from './shape.service';
import { ShapeService } from './shape.service';
export * from './shapeTranslation.service';
import { ShapeTranslationService } from './shapeTranslation.service';
export * from './systemOption.service';
import { SystemOptionService } from './systemOption.service';
/**
 * Aggregates all generated API service classes for Angular module providers.
 */
export const APIS = [AbmChangeActionService, AbmChangeEventService, AbmQueuedChangeService, AbmSequenceService, AbmSequenceHistoryService, AppUserService, BomImportFileService, BomRecordImportService, BomRecordQuarantineService, CompanyService, GradeService, GradeTranslationService, InventoryService, MetadataService, NestingCutlistService, NestingCutlistDetailService, NestingCutlistNestService, NestingCutlistNestDetailService, ProjectService, PurchaseOrderService, PurchaseOrderItemService, RequisitionService, RequisitionItemService, ShapeService, ShapeTranslationService, SystemOptionService];
